/* eslint-disable */

class filter {

  constructor() {

    this.$allActus = document.querySelectorAll('.person-item');
    this.$filtersWrapper = document.querySelector('.filters-wrapper');

    // data-* key name
    this.rank = "rank";

    this.addEventListener();

  }

  addEventListener() {
    document.body.addEventListener('click', e => {
      this.handleFilterClick(e);
    })
  }


  handleFilterClick(e) {

    const isFilterWrapperClicked = this.$filtersWrapper.contains(e.target);
    if (isFilterWrapperClicked) {
      this.resetChanges();
      this.filterActus(e);
    }
  }

  filterActus(e) {

    this.$allActus.forEach(actu => {
      if (e.target.getAttribute(`data-${this.rank}`)) this.subFilter(e.target, actu, this.rank);
    })
  }

  subFilter(target, item, dataKey) {
    if (item.getAttribute(`data-${dataKey}`) != target.getAttribute(`data-${dataKey}`)) {
      item.style.display = "none";
    }
  }


  resetChanges() {
    this.$allActus.forEach(actu => {
      if (actu.style.display === "none") actu.style.display = "block";
    })
  }
}

const pageCdos = document.querySelector('body.template-cdos');

if (pageCdos) {
  new filter();

  const filters = document.querySelectorAll('.filters-wrapper > li');

  filters.forEach(filter => {
    filter.onclick = event => {
      filters.forEach(f => f.classList.remove('is_active'))
      event.target.classList.add('is_active');
    }
  })

  document.body.addEventListener('click', function (e) {
    const isMoreInfosClicked = e.target.classList.contains('moreInfoBtn');
    const isLessInfosClicked = e.target.classList.contains('lessInfoBtn');
    console.log(e.target);
    if (isMoreInfosClicked) {
      e.target.parentNode.parentNode.querySelector('.more_infos').style.display = "block";
      e.target.parentNode.style.display = "none";
    }
    if (isLessInfosClicked) {
      e.target.parentNode.style.display = "none";
      e.target.parentNode.parentNode.querySelector('.first_infos').style.display = "block";
    }
  })
}



const infos = document.querySelectorAll('.infos');

infos.forEach(function (info) {
  info.addEventListener('mouseleave', function () {
    this.querySelector('.first_infos').style.display = "block";
    this.querySelector('.more_infos').style.display = "none";
  })
})


// WEBPACK FOOTER //
// ./scripts/cdosPage.js